import 'vue-slider-component/theme/default.css';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import VueSlider from 'vue-slider-component';
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import moment from 'moment-timezone';

import Vue from 'vue';
import VTooltip from 'v-tooltip';

import projectCreateDescription from '@/components/project/create/projectCreateDescription/index.vue';
import projectUpload from '@/components/projectUpload/index.vue';
import jobAttachUpload from '@/components/jobAttachUpload/index.vue';
import addFileForm from '@/components/addFileForm/index.vue';
import preloader from '@/components/preloader/index.vue';
import tasks from './tasks/index.vue';
import buttonLoader from '@/components/button';

import Api from '@/utils/api';

Vue.use(VTooltip);

export default Vue.extend({
  components: {
    VueSlider,
    DatePicker,
    Multiselect,
    projectCreateDescription,
    projectUpload,
    buttonLoader,
    jobAttachUpload,
    preloader,
    addFileForm,
    tasks,
  },
  data() {
    return {
      createParams: null,
      addProject: null,

      jobAttachments: [],
      sampleList: [0, 25, 50, 75, 100],
      description: {
        common: '',
        proofreader: `1) Accept the job "Evaluation"
2) Evaluate the translation quality in CrossWeb with the Plug-in myproof for Across
3) Save the QA report
4) Open the job in zf.myproof.net and upload the QA report
5) Write a statement about the translation quality
6) Optional: write a note for the QA expert or the project manager
7) Complete the job "Evaluation"`,
        qa: '',
      },
      lspList: [],

      availableMetrics: [],
      selectedSegmentKind: {},
      points: {},

      value: 70,
      marks: (val) => val % 5 === 0,

      qaModel: 0,
      typeDefault: 0,

      deadline: moment().hours(17),

      selectedEvaluationType: null,
      selectedQaMode: null,
      metric: null,
      segmenKinds: null,
      showLsp: false,
      fail: false,
      loading: false,
      dotHandlerClasses: ['low-70'],
      segmentsTypesList: [
        'Perfect match',
        'Context match',
        'Repetitions',
        'Cross-file repetitions',
        '100% match',
        '95-99% match',
        '85-94% match',
        '75-84% match',
        '50-74% match',
        'internal 95-99% match',
        'internal 85-94% match',
        'internal 75-84% match',
        'internal 50-74% match',
        'new translation/AT',
        'Adaptive MT Baseline',
        'Adaptive MT with Learnings',
      ],
    };
  },
  methods: {
    /**
     * Limit for multiselect
     *
     * @param {Integer} count
     */
    limitText(count) {
      return `and ${count} others`;
    },

    /**
     * Method for select metrics
     *
     * @param {Object} event
     */
    selMetric(event) {
      this.addProject.SelectedMetric = event;
    },

    /**
     * Method for select metrics
     *
     * @param {Object} event
     */
    selSegment(event) {
      this.addProject.SelectedSegmentKind = event.ID;
    },

    /**
     * Method for get time
     *
     * @param {Object} event
     */
    getTime(event) {
      this.addProject.DueDate = this.$filters.formatUnix(event);
    },

    /**
     * Method for get project params
     */
    getProjectParams() {
      this.addProject = this.$store.getters.addProject;
      this.addProject.Confidential = false;
      this.$set(this.addProject, 'Sample', 100);
      this.$set(this.addProject, 'LSPs', []);

      if (this.addProject == null) {
        this.$router.push({
          name: 'project_groups',
        });
      }

      Api.user.getLsp().then((data) => {
        if (data.data.Status) {
          this.lspList = data.data.Data;
        }
      });

      Api.projects.createProject.getParams().then((data) => {
        if (data.data.Status) {
          this.createParams = data.data.Data;

          this.createParams.SegmenKinds.find((value) => {
            if (value.ID === 1) {
              this.selectedSegmentKind = value;
              this.addProject.SelectedSegmentKind = value.ID;
            }
          });

          this.setAvailableMetrics();

          this.addProject.SelectedMetric = this.availableMetrics[1];

          this.addProject.QAMode = this.createParams.QAMods[1].ID;
          this.createParams.Risks.forEach((el) => {
            this.points[el.RiskValue] = el.Name;
          });

          this.addProject.IndustryFields = [
            this.createParams.IndustryFields.find((el) => el.Name === 'Automotive'),
          ];
        }
      });
    },

    /**
     * Method for creation project
     */
    create() {
      this.loading = true;

      this.$validator.validate().then((result) => {
        if (!result) {
          window.scrollTo(0, 0);
          this.loading = false;
          return;
        }

        this.getRiskLvl(this.addProject.Rating);
        if (this.addProject.DueDate == null) {
          this.addProject.DueDate = this.$filters.formatUnix(this.$filters.currentDate());
        }
        this.addProject.QADescription = this.description.qa;
        this.addProject.PRDescription = this.description.proofreader;
        this.addProject.GenDescription = this.description.common;

        Api.projects.createProject.create(this.addProject).then((response) => {
          if (!response.data.Status) {
            this.loading = false;

            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
              listError: response.data.ErrorValues,
            });

            return;
          }

          this.$root.$emit('notification', {
            message: 'Project was created! Redirecting...',
            type: 'info',
            show: true,
          });

          this.loading = false;

          setTimeout(() => {
            this.$router.push({
              path: '/project-groups/tile/filters/projects',
            });
          }, 2000);
        });
      });
    },

    /**
     * Set metrics
     */
    setAvailableMetrics() {
      this.availableMetrics = this.createParams.Metrics.filter((m) => {
        if (m.isDefault) {
          return m;
        }
      });

      this.createParams.Metrics.splice(0, 2);
    },

    /**
     * Get risk value
     *
     * @param {Number} value
     */
    getRiskLvl(value) {
      if (value == 100) {
        this.addProject.RiskLevelID = this.createParams.Risks[4].RiskID;
      } else if (value >= 95 && value < 100) {
        this.addProject.RiskLevelID = this.createParams.Risks[3].RiskID;
      } else if (value >= 90 && value < 95) {
        this.addProject.RiskLevelID = this.createParams.Risks[2].RiskID;
      } else if (value >= 80 && value < 90) {
        this.addProject.RiskLevelID = this.createParams.Risks[1].RiskID;
      } else if (value >= 65 && value < 80) {
        this.addProject.RiskLevelID = this.createParams.Risks[0].RiskID;
      } else {
        this.addProject.RiskLevelID = this.createParams.Risks[0].RiskID;
      }
    },

    setDotHandlerClass(value) {
      this.dotHandlerClasses.pop();
      this.dotHandlerClasses.push(value);
    },

    /**
     * Method for setting Risk level mark
     * @param {*} markLeftPos
     */
    setMarkColor(markLeftPos) {
      const markSpans = document.getElementsByName('risk-mark');
      markSpans.forEach((item) => {
        if (item.classList.length > 1) {
          item.classList.remove('active');
        }
        if (item.classList[0].split('-')[1] == markLeftPos) {
          item.classList.add('active');
        }
      });
    },

    /**
     *
     * Method for changing dot value color
     *
     * @param {Number} $event - Current quality level
     *
     */
    sliderChange($event) {
      switch ($event) {
      case 50:
        this.setDotHandlerClass('vlow-50');
        this.setMarkColor(30);
        break;
      case 55:
        this.setDotHandlerClass('vlow-55');
        this.setMarkColor(30);
        break;
      case 60:
        this.setDotHandlerClass('vlow-60');
        this.setMarkColor(30);
        break;
      case 65:
        this.setDotHandlerClass('vlow-65');
        this.setMarkColor(30);
        break;
      case 70:
        this.setDotHandlerClass('low-70');
        this.setMarkColor(60);
        break;
      case 75:
        this.setDotHandlerClass('low-75');
        this.setMarkColor(60);
        break;
      case 80:
        this.setDotHandlerClass('low-80');
        this.setMarkColor(60);
        break;
      case 85:
        this.setMarkColor(80);
        this.setDotHandlerClass('low-85');
        break;
      case 90:
        this.setMarkColor(80);
        this.setDotHandlerClass('med');
        break;
      case 95:
        this.setMarkColor(90);
        this.setDotHandlerClass('high');
        break;
      case 100:
        this.setMarkColor(100);
        this.setDotHandlerClass('crit');
        break;
      }
    },

    /**
     * Method set value
     *
     * TODO: (very bad, remove)
     *
     * @param {Number} ID
     * @param {Iteger} param
     */
    changeProjectConfigValues(ID, param) {
      switch (param) {
      case 1:
        this.addProject.QAMode = ID;
        break;
      case 2:
        this.addProject.SelectedSegmentKind = ID;
        break;
      case 3:
        this.addProject.SelectedMetric = ID;
        this.metric = null;
        break;
      }
    },
  },
});
